import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

const navItems = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    roles: ['ADMIN', 'PROVISIONER', 'DEPROVISIONER', 'APP_OWNER', 'MANAGER', 'AUDITOR']
  },
  {
    label: 'User Lifecycle',
    path: '/lifecycle',
    roles: ['ADMIN', 'PROVISIONER', 'DEPROVISIONER']
  },
  {
    label: 'Group Management',
    path: '/groups',
    roles: ['ADMIN', 'PROVISIONER']
  },
  {
    label: 'App Management',
    path: '/apps',
    roles: ['ADMIN', 'APP_OWNER']
  },
  {
    label: 'Access Reviews',
    path: '/reviews',
    roles: ['ADMIN', 'MANAGER']
  },
  {
    label: 'SoD Conflicts',
    path: '/sod',
    roles: ['ADMIN', 'AUDITOR']
  },
  {
    label: 'Audit Log',
    path: '/audit',
    roles: ['ADMIN', 'AUDITOR']
  },
  {
    label: 'Platform Users',
    path: '/platform-users',
    roles: ['ADMIN']
  }
];

const Sidebar = () => {
  const { user, logoutUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutUser();
    navigate('/login');
  };

  const filteredNav = navItems.filter(item => 
    item.roles.includes(user?.role)
  );

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>OktaGuardian</h2>
        <p>ABC Corp</p>
      </div>

      <nav className="sidebar-nav">
        {filteredNav.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              isActive ? 'nav-item active' : 'nav-item'
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <p className="sidebar-user-name">{user?.full_name}</p>
          <p className="sidebar-user-role">{user?.role}</p>
        </div>
        <button onClick={handleLogout} className="logout-btn">
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;